import { Address } from "../address.model";


export class AddressMapper {

    public static map(c: any[]): Address[] {
        let courses: Address[] = []
        c.forEach(x => {
            if (x != null) courses.push(new Address(x.AddressId, x.PostalCode, x.AddressLine, x.AptSuiteUnit, x.PoBox, x.CityTown, x.Province, x.Country))
        })
        return courses
    }
}
